export type StackSpacings = '0' | '25' | '50' | '100' | '200' | '300' | '400' | '500' | '700';
export type StackVerticalVariants =
    | boolean
    | 'up-to-extra-small'
    | 'up-to-small'
    | 'up-to-medium'
    | 'up-to-large'
    | 'from-small'
    | 'from-medium'
    | 'from-large'
    | 'from-extra-large';
export type StackDistribution = 'space-between' | 'stretch';
export type StackAlignment = 'start' | 'center' | 'end';
export type StackItemPadding = '0' | '50' | '100' | '200' | '300' | '400' | '500';

export interface StackProps {
    children: React.ReactNode;
    spacing?: StackSpacings;
    vertical?: StackVerticalVariants;
    distribution?: StackDistribution;
    alignment?: StackAlignment;
    itemAlignment?: StackAlignment;
    fill?: boolean;
    wrap?: boolean;
    inline?: boolean;
}

export interface StackItemProps {
    padding?: StackItemPadding;
    contentFit?: boolean;
    width?: string;
    minWidth?: string;
    grow?: boolean;
}
